import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const app = createApp(App)
app.use(router)

router.isReady().then(() => {
  app.mount('#app')
  // Dispatch event for prerenderer to know the app is ready
  document.dispatchEvent(new Event('render-event'))
})
